import { useAuth0 } from "@auth0/auth0-react";
import styles from "./groupfilter.module.css";
import { Plus, Search } from "react-feather";
import { Link } from "react-router-dom";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [
    { value: "Prospect", label: "Prospect" },
    { value: "Tenant", label: "Tenant" },
    { value: "Contact", label: "Contact" },
];

const GroupFilter = ({ filterData, setFilterData, setAddModalOpen }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey || ""} onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value } })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <FilterAutocomplete
                    label="Type"
                    options={TYPE_OPTIONS}
                    value={filterData?.type}
                    onChange={(value) => setFilterData(prev => {
                        return { ...prev, type: value };
                    })}
                />
            </div>
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-group:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
                <Plus /> <span>Group</span>
            </Link>}
        </div>
    </div>);
}

export default GroupFilter;